<template>
  <div class="relatorio-analise-reanalise">
    <div class="container-fluid py-4">
      <div
        class="row-top d-flex justify-content-between align-items-center mb-4"
      >
        <div class="col-top col-top-left">
          <button
            v-if="mostrarVoltar"
            class="btn btn-light no-print"
            @click="$router.push({ name: 'controleUsuarios' })"
          >
            <i class="fa fa-arrow-left"></i> Voltar
          </button>
        </div>
        <h1 class="titulo-relatorio">Relatório Análise / Reanálise</h1>
        <div class="col-top col-top-right">
          <button
            v-if="mostrarGerarPdf"
            class="btn btn-success btn-fill no-print"
            @click="gerarPdf"
          >
            Gerar PDF
          </button>
        </div>
      </div>

      <!-- Cabeçalho: informações do parceiro + mês/ano + logo na impressão -->
      <div class="relatorio-card mb-4">
        <div
          class="card-body d-flex align-items-center justify-content-between flex-wrap"
        >
          <div class="info-parceiro text-left">
            <p class="mb-1">
              <strong>Parceiro:</strong> {{ nomeParceiro || '—' }}
            </p>
            <p class="mb-1">
              <strong>Código:</strong> {{ codigoParceiro || '—' }}
            </p>
            <p class="mb-1">
              <strong>Data de emissão:</strong> {{ dataEmissao }}
            </p>
            <p class="mb-1">
              <strong>Mês:</strong>
              <span class="ml-2 no-print">
                <select
                  v-model="mesSelecionado"
                  class="form-control d-inline-block w-auto"
                  @change="carregarRelatorio"
                >
                  <option v-for="m in 12" :key="m" :value="m">
                    {{ MESES[m] }}
                  </option>
                </select>
              </span>
              <span class="print-only espaco-mes">{{
                nomeMes(mesSelecionado)
              }}</span>
            </p>
            <p class="mb-1">
              <strong>Ano:</strong>
              <span class="ml-2 no-print">
                <select
                  v-model="anoSelecionado"
                  class="form-control d-inline-block w-auto"
                  @change="carregarRelatorio"
                >
                  <option v-for="y in anosDisponiveis" :key="y" :value="y">
                    {{ y }}
                  </option>
                </select>
              </span>
              <span class="print-only espaco-ano">{{ anoSelecionado }}</span>
            </p>
          </div>
          <div class="logo-joule print-only">
            <img src="/img/joule-logo.png" alt="Joule" class="img-logo" />
          </div>
        </div>
      </div>

      <div v-if="loading" class="text-center py-5">Carregando...</div>
      <div v-else-if="erro" class="alert alert-danger">{{ erro }}</div>
      <template v-else-if="report">
        <div v-if="report.semDados" class="alert alert-info mb-4">
          Não há dados para esse parceiro no mês/ano selecionado.
        </div>
        <div v-else class="row align-items-stretch">
          <div class="col-lg-6 mb-4 d-flex flex-column">
            <div class="relatorio-card mb-4 flex-grow-1">
              <div class="card-header text-center">
                <h5 class="mb-0">Por concessionária</h5>
              </div>
              <div class="card-body tabela-analise-wrapper">
                <table class="table table-bordered table-sm tabela-analise">
                  <thead>
                    <tr>
                      <th class="th-concessionaria">Concessionária</th>
                      <th class="th-numero text-center">Análise</th>
                      <th class="th-numero text-center">Reanálise</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="row in report.tabela"
                      :key="row.concessionaria._id"
                    >
                      <td>{{ row.concessionaria.nome }}</td>
                      <td class="text-center">
                        {{ formatCelula(row.em_analise) }}
                      </td>
                      <td class="text-center">
                        {{ formatCelula(row.reanalise) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-body border-top pt-3">
                <div class="row">
                  <div class="col-6">
                    <strong>Performance:</strong>
                    <i
                      class="fa fa-question-circle text-muted ml-1 label-tooltip-icon no-print"
                      title="Percentual de projetos em reanálise sobre o total (em análise + reanálise) no mês."
                      aria-hidden="true"
                    />
                    {{ formatPerformance(report.performance) }}
                  </div>
                  <div class="col-6">
                    <strong>Média/dia:</strong>
                    <i
                      class="fa fa-question-circle text-muted ml-1 label-tooltip-icon no-print"
                      title="Média de projetos (em análise + reanálise) por dia no mês."
                      aria-hidden="true"
                    />
                    {{ formatCelula(report.mediaPorDia) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-lg-6 mb-4 d-flex flex-column charts-col"
            v-if="graficos.analise && graficos.reanalise"
          >
            <div class="relatorio-card mb-4 flex-fill d-flex flex-column">
              <div class="card-header text-center">
                <h5 class="mb-0">Análise</h5>
              </div>
              <div class="card-body chart-container flex-grow-1">
                <apexchart
                  v-if="graficos.analise"
                  type="line"
                  height="300"
                  :options="graficos.analise.options"
                  :series="graficos.analise.series"
                />
              </div>
            </div>

            <div class="relatorio-card mb-4 flex-fill d-flex flex-column">
              <div class="card-header text-center">
                <h5 class="mb-0">Reanálise</h5>
              </div>
              <div class="card-body chart-container flex-grow-1">
                <apexchart
                  v-if="graficos.reanalise"
                  type="line"
                  height="300"
                  :options="graficos.reanalise.options"
                  :series="graficos.reanalise.series"
                />
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import format from 'date-fns/format';
import VueApexCharts from 'vue-apexcharts';
import parceiroProjectService from 'src/services/parceiroProject';

const MESES = [
  '',
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro'
];

export default {
  name: 'RelatorioAnaliseReanalise',
  components: { apexchart: VueApexCharts },
  props: {
    codigoParceiro: { type: String, required: true }
  },
  data() {
    const anoAtual = new Date().getFullYear();
    const mesAtual = new Date().getMonth() + 1;
    const anos = [];
    const anoInicial = 2026;
    for (let y = anoInicial; y <= Math.max(anoAtual, anoInicial); y += 1)
      anos.push(y);
    return {
      MESES,
      nomeParceiro: '',
      report: null,
      loading: false,
      erro: null,
      mesSelecionado: mesAtual,
      anoSelecionado: anos.length ? anos[anos.length - 1] : anoAtual,
      anosDisponiveis: anos.length ? anos : [anoInicial],
      mostrarVoltar: true,
      dataEmissao: format(new Date(), 'dd/MM/yyyy HH:mm'),
      opcoesGraficoAnalise: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: { beginAtZero: true },
          x: { beginAtZero: true }
        }
      },
      opcoesGraficoReanalise: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: { beginAtZero: true },
          x: { beginAtZero: true }
        }
      },
      opcoesGraficoMensal: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: { beginAtZero: true },
          x: { beginAtZero: true }
        }
      },
      graficosStyles: {
        height: '300px',
        width: '100%',
        position: 'relative'
      },
      graficos: {
        analise: null,
        reanalise: null
      },
      codigoCliente: null
    };
  },
  computed: {
    mostrarGerarPdf() {
      return true;
      // return !this.report || !this.report.semDados;
    }
  },
  mounted() {
    this.nomeParceiro = this.$route.query.nomeParceiro || '';
    this.carregarRelatorio();
  },
  methods: {
    nomeMes(mes) {
      return MESES[mes] || mes;
    },
    formatCelula(val) {
      if (val == null) return '—';
      return val;
    },
    formatPerformance(val) {
      if (val == null) return '—';
      return `${Number(val).toFixed(2)}%`;
    },
    carregarRelatorio() {
      this.loading = true;
      this.erro = null;
      parceiroProjectService
        .getRelatorioAnaliseReanalise({
          codigoParceiro: this.codigoParceiro,
          ano: this.anoSelecionado,
          mes: this.mesSelecionado
        })
        .then(response => {
          this.report = response.data;
          if (response.data.semDados) {
            this.graficos = { analise: null, reanalise: null };
          } else {
            this.graficos = this.montarGraficosAnaliseReanalise(response.data);
          }
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            this.erro = error.response.data.message;
          } else {
            this.erro = 'Erro ao carregar relatório.';
          }
        });
    },
    opcoesLinhaApex(categories) {
      return {
        chart: {
          type: 'line',
          toolbar: { show: false },
          zoom: { enabled: false }
        },
        stroke: { curve: 'smooth', width: 2 },
        markers: { size: 4 },
        xaxis: { categories },
        dataLabels: { enabled: true },
        legend: { show: false },
        tooltip: { enabled: true }
      };
    },
    montarGraficosAnaliseReanalise(report) {
      const categories = [
        'Jan',
        'Fev',
        'Mar',
        'Abr',
        'Mai',
        'Jun',
        'Jul',
        'Ago',
        'Set',
        'Out',
        'Nov',
        'Dez'
      ];
      const padTo12 = arr => {
        if (!Array.isArray(arr)) return [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        const copy = [...arr];
        while (copy.length < 12) copy.push(0);
        return copy.slice(0, 12);
      };
      const analise = {
        series: [{ name: 'Análise', data: padTo12(report.chartAnalise) }],
        options: this.opcoesLinhaApex(categories)
      };
      const reanalise = {
        series: [{ name: 'Reanálise', data: padTo12(report.chartReanalise) }],
        options: this.opcoesLinhaApex(categories)
      };
      return { analise, reanalise };
    },
    gerarPdf() {
      const tituloOriginal = document.title;
      document.title = `Relatório Análise Reanálise - ${
        this.codigoParceiro
      } - ${this.nomeMes(this.mesSelecionado)} ${this.anoSelecionado}`;
      this.mostrarGerarPdf = false;
      this.mostrarVoltar = false;
      this.$nextTick(() => {
        setTimeout(() => {
          window.print();
          document.title = tituloOriginal;
          this.mostrarGerarPdf = true;
          this.mostrarVoltar = true;
        }, 300);
      });
    }
  }
};
</script>

<style scoped>
.relatorio-analise-reanalise {
  min-height: 100vh;
  background: #f4f4f4;
}

.row-top {
  position: relative;
}

.col-top {
  flex: 0 0 120px;
  min-width: 120px;
}

.col-top-left {
  text-align: left;
}

.col-top-right {
  text-align: right;
}

.titulo-relatorio {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin: 0;
  font-size: 1.75rem;
  font-weight: 600;
  text-align: center;
}

.print-only {
  display: none;
}

.print-only.espaco-mes,
.print-only.espaco-ano {
  margin-left: 0.35em;
}

.logo-joule .img-logo {
  height: 48px;
  width: auto;
}

.relatorio-card .card-header {
  background-color: transparent;
  border-bottom: none;
  padding-bottom: 0.5rem;
}

.relatorio-card .card-body {
  padding-top: 0.5rem;
}

.label-tooltip-icon {
  cursor: help;
  font-size: 0.9em;
  vertical-align: middle;
}

.chart-container {
  min-height: 280px;
  position: relative;
}

.tabela-analise-wrapper {
  overflow-x: auto;
  min-width: 0;
}

.relatorio-analise-reanalise .tabela-analise {
  table-layout: fixed;
  width: 100%;
  min-width: 280px;
  font-size: 2.1rem;
}

.relatorio-analise-reanalise .tabela-analise .th-concessionaria {
  width: 55%;
  min-width: 120px;
}

.relatorio-analise-reanalise .tabela-analise .th-numero {
  width: 22.5%;
  min-width: 70px;
}

.relatorio-analise-reanalise .tabela-analise th,
.relatorio-analise-reanalise .tabela-analise td {
  border: 1px solid #dee2e6 !important;
  padding: 0.5rem 0.75rem;
  vertical-align: middle;
}

.relatorio-analise-reanalise .tabela-analise td:first-child {
  word-break: break-word;
}

.relatorio-card {
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

@media screen and (max-width: 767px) {
  .relatorio-analise-reanalise .row-top {
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
  }
  .relatorio-analise-reanalise .row-top .col-top {
    flex: none;
    min-width: 0;
    text-align: center;
  }
  .relatorio-analise-reanalise .row-top .titulo-relatorio {
    position: static;
    transform: none;
  }
}

@media print {
  @page {
    margin: 12mm;
  }
  .print-only {
    display: inline !important;
  }
  .logo-joule.print-only {
    display: block !important;
  }
  .no-print {
    display: none !important;
  }
  .relatorio-analise-reanalise .row.align-items-stretch {
    flex-direction: column;
  }
  .relatorio-analise-reanalise .row.align-items-stretch .col-lg-6:first-child {
    max-width: 100%;
  }
  .charts-col {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    margin-left: 0 !important;
    margin-right: 0 !important;
    max-width: 100%;
    flex: 0 0 100%;
    width: 100%;
    flex-direction: row !important;
    flex-wrap: wrap;
    gap: 10px;
  }
  .charts-col .relatorio-card {
    flex: 0 0 calc(50% - 5px);
    max-width: calc(50% - 5px);
    width: calc(50% - 5px);
    box-sizing: border-box;
  }
  .chart-container {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    width: 100%;
    min-width: 100%;
  }
  .chart-container > div {
    margin: 0 auto;
    width: 100% !important;
    max-width: 100%;
  }
  .chart-container svg,
  .chart-container canvas {
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    display: block;
    margin: 0 auto;
  }
  .relatorio-card {
    break-inside: avoid;
  }
  .relatorio-analise-reanalise .tabela-analise th,
  .relatorio-analise-reanalise .tabela-analise td {
    border: 1px solid #000 !important;
  }
  .relatorio-analise-reanalise .tabela-analise {
    min-width: 280px;
  }
}
</style>
